import styled from 'styled-components'
import { mq } from '@styles/vars/media-queries.style'
import { colors } from '@styles/vars/colors.style'
import { clamp } from '@styles/utils/conversion.style'

export const FiltersControls = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    button {
        text-transform: capitalize;
        ${clamp('font-size', 16, 20)};
        line-height: 15px;
        > div {
            padding: 12px 16px !important;
            ${mq.tabletLMax} {
                border: unset !important;
                background: transparent !important;
                color: ${colors.charcoal} !important;
                span {
                    display: flex;
                    align-items: center;
                }
            }
        }
        ${mq.tabletLMax} {
            width: 100%;
            padding: 12px 5px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            &:not(:last-child) {
                border-bottom: 1px solid #E8E8E8;
            }
        }
    }
    ${mq.tabletLMax} {
        display: block;
        position: absolute;
        width: 320px;
        max-width: calc(100vw - 60px);
        left: 0;
        top: calc(100% + 12px);
        border: 1px solid #E8E8E8;
        box-shadow: 1px 0px 20px rgba(218, 218,218,0.5);
        background: ${colors.white};
        border-radius: 4px;
        z-index: 5;
        transition: all 0.25s ease;
        opacity: ${props => props.active ? '1' : '0'};
        transform: ${props => props.active ? 'translateY(0)' : 'translateY(-10px)'};
        visibility: ${props => props.active ? 'visible' : 'hidden'};
        
    }
`
export const FiltersContainer = styled.div`
    position: relative;
    margin-right: auto;
    flex: 1;
`

export const FiltersButton = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid ${colors.charcoal};
    border-radius: 7rem;
    cursor: pointer;
    background: ${colors.white};
    max-width: 233px;
    padding: 5px 5px 5px 14px;

    svg {
        margin-right: auto;
        width: 24px;
        height: 26px;
    }
    ${mq.tabletL} {
        display: none;
    }
`

export const FiltersTitle = styled.div`
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-right: 10px;
    line-height: 15px;
    
    ${mq.mobileMax} {
        text-overflow: clip;
    }
`

export const Check = styled.div`
    ${mq.tabletL} {
        display: none;
    }
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid ${colors.charcoal};
    border-radius: 2px;
    margin-right: 10px;
    background: ${props => props.active ? colors.charcoal : colors.white};
    svg {
        color: ${colors.white};
        opacity: ${props => props.active ? '1' : '0'};
        height: 18px;
        width: 18px;
        stroke-width: 3px;
        position: absolute;
    }
`